<template>
  <div class="mdm_group_page">
    <div class="d-flex align-center justify-space-between">
      <h3 class="title-page">{{ $t("warehouse") }}</h3>
      <button class="infoVideo" @click="openInfoVideoModal">
        <span class="text-primary cursor-pointer">{{
          $t("videoInstruction")
        }}</span>
      </button>
    </div>
    <div class="actions_container">
      <v-btn
        color="primary"
        dark
        style="display: block"
        @click="openWarehouseCreateModal"
        v-if="permissions.warehouses.WAREHOUSE_CREATE"
      >
        <v-icon left> mdi-plus-circle</v-icon>
        {{ createButtonLoading ? $t("loading") : $t("create") }}
      </v-btn>
      <!--      <VBtn-->
      <!--        v-if="$can($permissions.INCOME_PRODUCT_FROM_EXCEL)"-->
      <!--        href="/files/product-item-import.xls"-->
      <!--        color="primary"-->
      <!--      >-->
      <!--        <v-icon left> mdi-download-box</v-icon>-->
      <!--        {{ $t("downloadTemplateFile") }}-->
      <!--      </VBtn>-->
      <custom-input-text
        @input="onChangeFilter"
        class="user_input no-margin ml-3"
        v-model="warehouseFilter.name"
        clearable
        :placeholder="$t('searchForName')"
      >
        <template #prepend-inner>
          <v-icon>mdi-magnify</v-icon>
        </template>
      </custom-input-text>
    </div>
    <div>
      <div class="tabs">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab"
          @click="activateTab(tab.id)"
          :class="tab.id === activeTabIndex ? 'active' : ''"
        >
          <span>
            {{ index === 0 ? $t("all") : tab.title }}
          </span>
        </div>
        <div
          class="tab plus"
          v-if="permissions.zone.ZONE_ACTIONS"
          @click.stop="zoneDialogOpen"
        >
          <v-icon>mdi-plus-circle-outline</v-icon>
        </div>
      </div>

      <div
        v-for="tab in tabs"
        :key="tab.id"
        v-show="tab.id === activeTabIndex"
        class="tab-content"
      >
        <template v-if="tab.id !== 'all'">
          <div
            class="zona_btn_container d-flex justify-end mb-3"
            style="gap: 20px"
          >
            <v-btn
              color="white"
              @click="editZona(tab.id)"
              v-if="permissions.zone.ZONE_ACTIONS"
              style="color: #0096b2; border: 1px solid #dfe2e9 !important"
              >{{ $t("edit") }}
            </v-btn>
            <v-btn
              color="white"
              @click="deleteZona(tab.id)"
              v-if="permissions.zone.ZONE_ACTIONS"
              style="color: #ff6969; border: 1px solid #dfe2e9 !important"
              >{{ `${$t("delete")} ${$t("zone")}` }}
            </v-btn>
          </div>
        </template>
        <div class="card_container">
          <template v-if="currentItems.length">
            <v-card
              v-for="item in currentItems"
              :key="item.id"
              style="
                border-radius: 5px;
                border: 2px solid #e3ebf3;
                background: #fff;
              "
              class="warehouse-v-card"
            >
              <v-card-text>
                <div class="d-flex justify-space-between items-center">
                  <p
                    style="
                      font-size: 14px;
                      font-weight: 550;
                      margin-bottom: 0;
                      color: #48545d;
                    "
                  >
                    {{
                      item[
                        `name${
                          $i18n.locale.charAt(0).toUpperCase() +
                          $i18n.locale.slice(1)
                        }`
                      ]
                    }}
                  </p>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <button v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </button>
                    </template>
                    <v-list class="warehouse-offset-y">
                      <v-list-item
                        @click.stop
                        :to="{
                          name: 'warehouse-view',
                          params: { id: item.id },
                          query: { productName: warehouseFilter.name },
                        }"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-warehouse</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          >{{ $t("warehouse") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click.stop
                        :to="{
                          name: 'warehouse-view',
                          params: { id: item.black_id },
                        }"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-package-variant</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                          {{ $t("goBlackWarehouse") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click.stop
                        :to="{
                          name: 'a-product-omtk',
                          params: { id: item.id },
                          query: { productName: warehouseFilter.name },
                        }"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-eye</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          >{{ $t("products") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="permissions.warehouses.WAREHOUSE_CREATE"
                        @click.stop="openAttachZoneModal(item)"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-map-marker-path</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                          {{ $t("attachToZone") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="$can($permissions.INCOME_PRODUCT_FROM_EXCEL)"
                        @click.stop="
                          $refs.warehouseImportProductDialogRef.open({
                            name: item.name,
                            warehouseId: item.id,
                          })
                        "
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-file-table-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          >{{ $t("importFromExcel") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="item.longitude && item.latitude"
                        @click.stop="
                          $refs.mapNavigationDialogRef.open({
                            warehouseName: item.name,
                            warehouseId: item.id,
                            latitude: item.latitude,
                            longitude: item.longitude,
                          })
                        "
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-map-legend</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                          {{ $t("showOnTheMap") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="permissions.warehouses.WAREHOUSE_CREATE"
                        @click.stop
                        :to="{
                          name: 'reference-warehouse-edit',
                          params: { id: item.black_id },
                        }"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-store-edit</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          >{{ $t("editBlackWarehouse") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="permissions.warehouses.WAREHOUSE_CREATE"
                        @click.stop
                        :to="{
                          name: 'reference-warehouse-edit',
                          params: { id: item.id },
                        }"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey"
                            >mdi-store-edit-outline
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          >{{ $t("editWarehouse") }}
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item
                        v-if="permissions.warehouses.WAREHOUSE_CREATE"
                        @click="edit(item)"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-pencil</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("edit") }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="permissions.warehouses.WAREHOUSE_CREATE"
                        @click="deleteItem(item)"
                      >
                        <v-list-item-icon style="margin-right: 10px">
                          <v-icon color="lightGrey">mdi-delete</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          >{{ $t("delete") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="text--primary mt-5">
                  <div style="display: flex">
                    <p class="d-flex align-center">
                      <vue-icon icon="zoneTypeIcon" />
                      <span style="color: #7a889b" class="ml-2"
                        >{{ $t("zone") }}:</span
                      >
                    </p>
                    <p style="flex-grow: 1; text-align: end; font-weight: 700">
                      {{ getZoneName(item.groupId) }}
                    </p>
                  </div>
                  <div style="display: flex">
                    <p class="d-flex align-center">
                      <vue-icon icon="stellageCountIcon" />
                      <span style="color: #7a889b" class="ml-2"
                        >{{ $t("numberOfStillage") }}:</span
                      >
                    </p>
                    <p style="flex-grow: 1; text-align: end; font-weight: 700">
                      {{ item.stillage_count }}
                    </p>
                  </div>

                  <div class="d-flex">
                    <div class="d-flex gap-2 align-center">
                      <p
                        :style="{
                          borderRadius: '4px',
                          marginBottom: '0 !important',
                          width: '20px',
                          height: '20px',
                          background:
                            item && item.occupancyPercent > 90
                              ? '#EB5757'
                              : item.occupancyPercent > 48
                              ? '#e2c25d'
                              : '#49bb8b',
                        }"
                      ></p>
                      <span style="color: #7a889b" class="ml-2">{{
                        $t("fullParcent")
                      }}</span>
                    </div>
                    <p
                      style="
                        flex-grow: 1;
                        text-align: end;
                        margin-bottom: 0 !important;
                        font-weight: 700;
                      "
                    >
                      {{ item.occupancyPercent ? item.occupancyPercent : 0 }}%
                    </p>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </template>
          <template v-else>
            <div class="d-flex justify-center mb-3">
              {{ $t("warehouseNotHere") }}
            </div>
          </template>
        </div>
      </div>
      <!--      <table-with-filter-->
      <!--        fixed-header-->
      <!--        :height="$vuetify.breakpoint.height - 178"-->
      <!--        :headers="headers"-->
      <!--        :items="items"-->
      <!--        @click:item="openView"-->
      <!--      >-->
      <!--        <template #filter.name>-->
      <!--          <div class="d-flex pa-1">-->
      <!--            <custom-select-->
      <!--              style="width: 30%"-->
      <!--              :placeholder="-->
      <!--                $t('productName') + ' ' + '//' + ' ' + $t('warehouse')-->
      <!--              "-->
      <!--              class="user_input no-margin"-->
      <!--              :items="nameSearch"-->
      <!--              item-text="name"-->
      <!--              item-value="value"-->
      <!--              v-model="selectedFilter"-->
      <!--              @input="filterChangeSelected"-->
      <!--            />-->
      <!--            <custom-input-text-->
      <!--              style="width: 70%"-->
      <!--              @input="onChangeFilter"-->
      <!--              class="user_input no-margin ml-3"-->
      <!--              v-model="warehouseFilter.name"-->
      <!--              clearable-->
      <!--            />-->
      <!--          </div>-->
      <!--        </template>-->
      <!--        <template #item.occupancyPercent="{ item: { occupancyPercent } }">-->
      <!--          <div style="width: 200px; margin: auto">-->
      <!--            <chart-bar-->
      <!--              :title="-->
      <!--                $t('occupiedPlacePercent', { percent: occupancyPercent || 0 })-->
      <!--              "-->
      <!--              :value="+occupancyPercent || 0"-->
      <!--              color="#E46B6B"-->
      <!--              style="background: #b1acac"-->
      <!--              dark-->
      <!--            />-->
      <!--          </div>-->
      <!--        </template>-->
      <!--        <template #item.action="{ item }">-->
      <!--          <VBtn-->
      <!--            @click.stop-->
      <!--            :to="{-->
      <!--              name: 'a-product-omtk',-->
      <!--              params: { id: item.id },-->
      <!--              query: { productName: warehouseFilter.name },-->
      <!--            }"-->
      <!--            class="btn_33 edit_btn"-->
      <!--          >-->
      <!--            <vue-icon icon="eyeIcon" />-->
      <!--          </VBtn>-->
      <!--          <VBtn-->
      <!--            v-if="$can($permissions.INCOME_PRODUCT_FROM_EXCEL)"-->
      <!--            @click.stop="-->
      <!--              $refs.warehouseImportProductDialogRef.open({-->
      <!--                name: item.name,-->
      <!--                warehouseId: item.id,-->
      <!--              })-->
      <!--            "-->
      <!--            class="btn_33 edit_btn"-->
      <!--          >-->
      <!--            <VueIcon icon="fileIcon" />-->
      <!--          </VBtn>-->
      <!--        </template>-->
      <!--      </table-with-filter>-->
      <v-dialog
        v-model="dialog"
        class="user_modal_dialog"
        width="auto"
        persistent
        @click:outside="modalClose"
      >
        <v-card style="width: 950px" class="warehouse_modal">
          <validation-observer ref="form" v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(saveAttribute)">
              <div class="warehouse_overlay">
                <v-card-text class="warehouse_40">
                  <v-card-title style="padding-left: 0" class="headline"
                    >{{ formTitle }}
                  </v-card-title>
                  <v-card-subtitle style="padding-left: 0"
                    >{{ $t("createWarehouseSubTitle") }}
                  </v-card-subtitle>
                  <div class="mt-3">
                    <custom-input-text
                      v-model="formData.nameUz"
                      :placeholder="$t('name')"
                      rules="required"
                      :name="$t('name')"
                    >
                      <template #prepend-inner>
                        <vue-icon class="mr-2" icon="warehouseNameIcon" />
                      </template>
                    </custom-input-text>
                  </div>
                  <div class="mt-3 mb-5 d-flex">
                    <vue-select
                      infinite
                      item-text="name_uz"
                      prepend-icon="warehouseTypeIcon"
                      :placeholder="$t('selectZoneForWarehousePlaceholder')"
                      @changeText="getAllWarehouseGroups"
                      @focus="getAllWarehouseGroups('')"
                      v-model="formData.groupId"
                      :items="warehouseGroup"
                      clearable
                      class="user_input no-margin"
                      style="width: 100%; max-width: 246px"
                    >
                    </vue-select>
                    <!--                    <div class="tooltip" style="margin-left: 80px">-->
                    <!--                      <v-icon>mdi-help-circle</v-icon>-->
                    <!--                      <span class="tooltiptext">-->
                    <!--                        <h4>{{ $t("typeWarehouses") }}</h4>-->
                    <!--                        <span>-->
                    <!--                          <pre>- {{ $t("areaWarehouse") }}</pre>-->
                    <!--                          - {{ $t("areaWarehouseDescription") }}-->
                    <!--                        </span>-->
                    <!--                        <span>-->
                    <!--                          <pre>- {{ $t("regularWarehouse") }}</pre>-->
                    <!--                          - {{ $t("regularWarehouseDescription") }}-->
                    <!--                        </span>-->
                    <!--                      </span>-->
                    <!--                    </div>-->
                  </div>

                  <div class="mt-3">
                    <custom-input-text
                      v-model="formData.address"
                      :placeholder="$t('address')"
                      rules="required"
                    >
                      <template #append>
                        <v-switch
                          v-model="isAddressHaveGeolocation"
                          dense
                          hide-details
                        ></v-switch>
                      </template>
                      <template #prepend-inner>
                        <vue-icon icon="geolacationIcon" />
                      </template>
                    </custom-input-text>
                  </div>
                  <div class="mt-3 d-flex align-center">
                    <custom-input-text
                      :placeholder="$t('hiddenWarehouses')"
                      disabled
                    >
                      <template #append>
                        <v-switch
                          v-model="formData.hidden"
                          dense
                          hide-details
                        ></v-switch>
                      </template>
                      <template #prepend-inner>
                        <vue-icon icon="closeEyeIcon" />
                      </template>
                    </custom-input-text>
                    <div
                      class="tooltip"
                      style="
                        margin-left: 8px;
                        margin-bottom: 5px;
                        z-index: 1000;
                      "
                    >
                      <v-icon>mdi-help-circle</v-icon>
                      <span class="tooltiptext">
                        <h4>{{ $t("hiddenWarehouse") }}</h4>
                        <span>{{ $t("hiddenWarehouseDescription") }} </span>
                      </span>
                    </div>
                  </div>
                  <hr
                    style="
                      background-color: #dfe2e9;
                      margin-top: 10px;
                      border: none;
                      height: 1px;
                    "
                  />
                </v-card-text>
                <div class="modal_right_side">
                  <img
                    v-if="!isAddressHaveGeolocation"
                    class="warehouse_add_modal_img"
                    src="../../../assets/img/warehouse-img.png"
                    alt=""
                  />
                  <div v-else>
                    <GeolacationPicker
                      w="100%"
                      h="326px"
                      @marker-moved="setMarkedMove"
                    />
                  </div>
                </div>
              </div>
              <!--              <v-container style="width: 1024px; height: 602px">-->
              <!--                <div>-->
              <!--                  <v-card-title>Создать склад </v-card-title>-->
              <!--                  <v-card-subtitle>Начинаем с чистого листа</v-card-subtitle>-->
              <!--                  <v-row>-->
              <!--                    <v-col>-->
              <!--                      <div class="input_container">-->
              <!--                        <vue-icon icon="warehouseNameIcon" />-->
              <!--                        <input placeholder="Название" />-->
              <!--                      </div>-->
              <!--                    </v-col>-->
              <!--                  </v-row>-->
              <!--                  <v-row>-->
              <!--                    <v-col>-->
              <!--                      <div-->
              <!--                        class="input_container"-->
              <!--                        style="justify-content: space-between"-->
              <!--                      >-->
              <!--                        <div class="d-flex align-center" style="gap: 5px">-->
              <!--                          <vue-icon icon="warehouseTypeIcon" />-->
              <!--                          <div class="custom-select" @click="toggleDropdown">-->
              <!--                            <div-->
              <!--                              class="selected-option"-->
              <!--                              :class="{-->
              <!--                                placeholder:-->
              <!--                                  selectedOption === 'Select an option',-->
              <!--                              }"-->
              <!--                            >-->
              <!--                              {{ selectedOption }}-->
              <!--                            </div>-->
              <!--                            <div class="options" :class="isOpen ? 'show' : ''">-->
              <!--                              <div-->
              <!--                                v-for="option in options"-->
              <!--                                :key="option"-->
              <!--                                @click.stop="selectOption(option)"-->
              <!--                              >-->
              <!--                                {{ option }}-->
              <!--                              </div>-->
              <!--                            </div>-->
              <!--                          </div>-->
              <!--                        </div>-->

              <!--                        <v-icon-->
              <!--                          >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}-->
              <!--                        </v-icon>-->
              <!--                      </div>-->
              <!--                    </v-col>-->
              <!--                  </v-row>-->
              <!--                </div>-->
              <!--                <div></div>-->
              <!--              </v-container>-->
              <div class="btn_container">
                <v-btn color="grey" @click="modalClose" type="button"
                  >{{ $t("cancel") }}
                </v-btn>
                <v-btn color="primary" dark type="submit" :loading="loading"
                  >{{ $t("save") }}
                </v-btn>
              </div>
            </v-form>
          </validation-observer>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="zone_dialog"
        class="user_modal_dialog"
        width="auto"
        persistent
        @click:outside="closeZone"
      >
        <v-card style="width: 912px" class="warehouse_modal zone">
          <validation-observer ref="form" v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(saveZoneAttribute)">
              <div class="warehouse_overlay">
                <v-card-text class="warehouse_40">
                  <v-card-title style="padding-left: 0" class="headline"
                    >{{ zoneModalTitle }}
                  </v-card-title>
                  <v-card-subtitle style="padding-left: 0"
                    >{{ $t("createWarehouseSubTitle") }}
                  </v-card-subtitle>
                  <div class="mt-3">
                    <custom-input-text
                      v-model="zonaFormData.nameUz"
                      :placeholder="$t('name')"
                      rules="required"
                      :name="$t('name')"
                    >
                      <template #prepend-inner>
                        <vue-icon class="mr-2" icon="warehouseNameIcon" />
                      </template>
                    </custom-input-text>
                  </div>
                  <div class="mt-3">
                    <custom-input-text
                      v-model="zonaFormData.address"
                      :placeholder="$t('address')"
                      rules="required"
                    >
                      <template #append>
                        <v-switch
                          v-model="isZoneAddressHaveGeolocation"
                          dense
                          hide-details
                        ></v-switch>
                      </template>
                      <template #prepend-inner>
                        <vue-icon icon="geolacationIcon" />
                      </template>
                    </custom-input-text>
                  </div>
                  <!--                  <div class="mt-3 d-flex align-center">-->
                  <!--                    <custom-input-text-->
                  <!--                      :placeholder="$t('hiddenWarehouses')"-->
                  <!--                      style="width: 286px"-->
                  <!--                      disabled-->
                  <!--                    >-->
                  <!--                      <template #append>-->
                  <!--                        <v-switch-->
                  <!--                          v-model="zonaFormData.hidden"-->
                  <!--                          dense-->
                  <!--                          hide-details-->
                  <!--                        ></v-switch>-->
                  <!--                      </template>-->
                  <!--                      <template #prepend-inner>-->
                  <!--                        <vue-icon icon="closeEyeIcon" />-->
                  <!--                      </template>-->
                  <!--                    </custom-input-text>-->
                  <!--                    <div-->
                  <!--                      class="tooltip"-->
                  <!--                      style="margin-left: 8px; margin-bottom: 5px"-->
                  <!--                    >-->
                  <!--                      <v-icon>mdi-help-circle</v-icon>-->
                  <!--                      <span class="tooltiptext">-->
                  <!--                        <h4>{{ $t("hiddenWarehouse") }}</h4>-->
                  <!--                        <span>{{ $t("hiddenWarehouseDescription") }} </span>-->
                  <!--                      </span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div
                    style="height: 36px; margin-top: 12px; margin-bottom: 20px"
                  >
                    <!--                    <vue-select-->
                    <!--                      v-if="formData.hidden"-->
                    <!--                      infinite-->
                    <!--                      prepend-icon="warehouseAccessUserIcon"-->
                    <!--                      :placeholder="$t('selectWarehouseType')"-->
                    <!--                      ref="warehouseListSelect"-->
                    <!--                      :get-item-promise="-->
                    <!--                        ({ text, page }) =>-->
                    <!--                          $store.dispatch('getUsers', {-->
                    <!--                            name: text,-->
                    <!--                            page,-->
                    <!--                            limit: 15,-->
                    <!--                          })-->
                    <!--                      "-->
                    <!--                      @item-resolved="setWarehouse"-->
                    <!--                      @next-page-resolved="-->
                    <!--                        (data) => setWarehouse([...warehouses, ...data])-->
                    <!--                      "-->
                    <!--                      v-model="formData.parentId"-->
                    <!--                      :items="warehouses"-->
                    <!--                      clearable-->
                    <!--                      multiple="true"-->
                    <!--                    >-->
                    <!--                    </vue-select>-->
                  </div>
                  <hr
                    style="background-color: #dfe2e9; border: none; height: 1px"
                  />
                </v-card-text>
                <div class="modal_right_side">
                  <img
                    v-if="!isZoneAddressHaveGeolocation"
                    class="warehouse_add_modal_img"
                    src="../../../assets/img/warehouse-img.png"
                    alt=""
                  />
                  <div v-else>
                    <GeolacationPicker
                      :lat="computedLat"
                      :lang="computedLng"
                      w="100%"
                      h="326px"
                      @marker-moved="setZonaMarkedMove"
                    />
                  </div>
                </div>
              </div>
              <div class="btn_container">
                <v-btn color="grey" @click="closeZone" type="button"
                  >{{ $t("cancel") }}
                </v-btn>
                <v-btn color="primary" dark type="submit" :loading="loading"
                  >{{ $t("save") }}
                </v-btn>
              </div>
              <!--              <v-container style="width: 1024px; height: 602px">-->
              <!--                <div>-->
              <!--                  <v-card-title>Создать склад </v-card-title>-->
              <!--                  <v-card-subtitle>Начинаем с чистого листа</v-card-subtitle>-->
              <!--                  <v-row>-->
              <!--                    <v-col>-->
              <!--                      <div class="input_container">-->
              <!--                        <vue-icon icon="warehouseNameIcon" />-->
              <!--                        <input placeholder="Название" />-->
              <!--                      </div>-->
              <!--                    </v-col>-->
              <!--                  </v-row>-->
              <!--                  <v-row>-->
              <!--                    <v-col>-->
              <!--                      <div-->
              <!--                        class="input_container"-->
              <!--                        style="justify-content: space-between"-->
              <!--                      >-->
              <!--                        <div class="d-flex align-center" style="gap: 5px">-->
              <!--                          <vue-icon icon="warehouseTypeIcon" />-->
              <!--                          <div class="custom-select" @click="toggleDropdown">-->
              <!--                            <div-->
              <!--                              class="selected-option"-->
              <!--                              :class="{-->
              <!--                                placeholder:-->
              <!--                                  selectedOption === 'Select an option',-->
              <!--                              }"-->
              <!--                            >-->
              <!--                              {{ selectedOption }}-->
              <!--                            </div>-->
              <!--                            <div class="options" :class="isOpen ? 'show' : ''">-->
              <!--                              <div-->
              <!--                                v-for="option in options"-->
              <!--                                :key="option"-->
              <!--                                @click.stop="selectOption(option)"-->
              <!--                              >-->
              <!--                                {{ option }}-->
              <!--                              </div>-->
              <!--                            </div>-->
              <!--                          </div>-->
              <!--                        </div>-->

              <!--                        <v-icon-->
              <!--                          >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}-->
              <!--                        </v-icon>-->
              <!--                      </div>-->
              <!--                    </v-col>-->
              <!--                  </v-row>-->
              <!--                </div>-->
              <!--                <div></div>-->
              <!--              </v-container>-->
            </v-form>
          </validation-observer>
        </v-card>
      </v-dialog>
      <v-dialog
        max-width="400"
        v-model="attach_zone"
        @click:outside="attach_zone = false"
      >
        <v-card class="warehouse_modal zone_attach">
          <validation-observer ref="form" v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(saveAttribute)">
              <div
                class="d-flex align-center"
                style="
                  justify-content: space-between;
                  padding-right: 20px;
                  border-bottom: 1px solid #dfe2e9;
                "
              >
                <v-card-title>{{ $t("attachToZone") }}</v-card-title>
                <span @click="attach_zone = false">
                  <vue-icon class="cursor-pointer" icon="newBoldCloseIcon" />
                </span>
              </div>
              <v-card-text>
                <div class="mt-2">
                  <pre style="color: #a2a5b9; font-size: 12px"
                    >{{ $t("warehouse") }}:</pre
                  >
                  <span
                    style="color: #48545d; font-size: 16px; font-weight: 600"
                    >{{
                      formData[
                        `name${
                          $i18n.locale.charAt(0).toUpperCase() +
                          $i18n.locale.slice(1)
                        }`
                      ]
                    }}</span
                  >
                </div>
                <div class="mt-2">
                  <span
                    style="
                      color: #48545d;
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 400;
                    "
                    >{{ $t("selectZoneWhichYouWant") }}
                  </span>
                  <vue-select
                    infinite
                    item-text="name_uz"
                    prepend-icon="warehouseTypeIcon"
                    :placeholder="$t('selectZoneForWarehousePlaceholder')"
                    @changeText="getAllWarehouseGroups"
                    @blur="getAllWarehouseGroups"
                    v-model="formData.groupId"
                    :items="warehouseGroup"
                    clearable
                    class="user_input no-margin mt-2"
                  >
                  </vue-select>
                </div>
                <div class="mt-6">
                  <v-btn type="submit" width="100%" color="primary"
                    >{{ $t("apply") }}
                  </v-btn>
                </div>
              </v-card-text>
            </v-form>
          </validation-observer>
        </v-card>
      </v-dialog>

      <v-dialog max-width="556px" v-model="limitModal">
        <v-card>
          <v-card-title class="justify-end">
            <span class="cursor-pointer" @click="limitModal = false">
              <vue-icon icon="newBoldCloseIcon" />
            </span>
          </v-card-title>
          <div
            class="d-flex flex-column align-center text-container mb-4 px-10 pb-4"
            style="gap: 10px"
          >
            <img src="../../../assets/img/info-icon.png" alt="limit img" />
            <h3
              class="modalTitle"
              style="text-align: center"
              v-html="checkErrorMessageTitle"
            ></h3>
            <p
              class="modalDescription"
              style="text-align: center"
              v-html="checkErrorMessageDescription"
            ></p>
            <div class="action-container d-flex mt-3" style="gap: 10px">
              <v-btn color="grey" @click="limitModal = false"
                >{{ $t("close") }}
              </v-btn>
              <v-btn
                color="primary"
                :href="checkErrorButtonLink"
                @click="limitModal = false"
                >{{ checkErrorButtontext }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <warning-dialog
        v-model="confirmDialog"
        @apply="deleteItemHandler"
      ></warning-dialog>
      <warning-dialog
        v-model="zoneConfirmDialog"
        @apply="deleteZonaHandler"
      ></warning-dialog>
    </div>
    <vue-pagination
      go-to
      @update:limit="
        (limit) => {
          configuration.limit = limit;
          configuration.page = 1;
          changePage();
        }
      "
      v-model="configuration.page"
      :length="lastPage"
      @input="changePage"
      :limit="configuration.limit"
    />
    <WarehouseImportProductDialog ref="warehouseImportProductDialogRef" />
    <NavigationModal ref="mapNavigationDialogRef" />
    <NotificationSystem ref="warehouseNotification" />
    <v-dialog max-width="700px" v-model="infoVideoModal">
      <v-card style="padding: 10px 20px">
        <h4 class="mb-2">{{ $t("productManagementTitle") }}</h4>
        <video
          class="videoPlayer"
          style="width: 100%; height: 100%"
          muted
          autoplay
          controls
          controlslist="nodownload"
        >
          <source src="@/assets/img/video/wmsproduct.mp4" type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  debounce,
  getValueByKey,
  makerPagination,
} from "@/utils/pureFunctions";
// import ChartBar from "@/components/ui/chart/ChartBar";
// import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import WarehouseImportProductDialog from "@/components/warehouse/WarehouseImportProductDialog.vue";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";
import GeolacationPicker from "@/components/warehouse/GeolacationPicker.vue";
import NavigationModal from "@/components/warehouse/NavigationModal.vue";
import NotificationSystem from "@/components/notificationSystem.vue";

const DEFAULT_WAREHOUSE_FILTER = {
  name: null,
};

const DEFAULT_WAREHOUSE_DATA = {
  nameRu: null,
  nameUz: null,
  nameEn: null,
  address: null,
  parentId: null,
  parent: null,
  id: null,
  hidden: null,
  groupId: null,
};

const DEFAULT_ZONA_DATA = {
  nameUz: null,
  nameRu: null,
  nameEn: null,
  hidden: null,
  address: null,
  id: null,
};

export default {
  components: {
    NotificationSystem,
    NavigationModal,
    GeolacationPicker,
    WarningDialog,
    WarehouseImportProductDialog,
    VuePagination,
    VueSelect,
  },
  data() {
    return {
      permissions: {
        zone: {},
        warehouses: {},
      },
      tabs: [{ title: this.$t("all"), id: "all" }],
      activeTabIndex: 0,
      showModal: false,
      createButtonLoading: false,
      checkErrorMessageTitle: "",
      checkErrorButtontext: "",
      checkErrorButtonLink: "",
      checkErrorMessageDescription: "",
      newTabTitle: "",
      limitModal: false,
      infoVideoModal: false,
      confirmDialog: false,
      zoneConfirmDialog: false,
      selectedWarehouseId: null,
      warehouseFilter: {
        ...DEFAULT_WAREHOUSE_FILTER,
      },
      warehouses: [],
      warehouseGroup: [],
      dialog: false,
      zone_dialog: false,
      attach_zone: false,
      formData: { ...DEFAULT_WAREHOUSE_DATA },
      zonaFormData: { ...DEFAULT_ZONA_DATA },
      /**
       * @type string
       * @param stillage_count
       */
      loading: false,
      items: [],
      isCanCreateWarehouse: false,
      currentItems: [],
      zones: [],
      configuration: {
        limit: 30,
        page: 1,
      },
      lastPage: 0,
      selectedFilter: 2,
      isAddressHaveGeolocation: false,
      isZoneAddressHaveGeolocation: false,
      latitude: null,
      longitude: null,
      zonaLatitude: null,
      zonaLongitude: null,
      isOpen: false,
      selectedOption: "Select an option",
      options: ["Option 1", "Option 2", "Option 3"],
    };
  },
  computed: {
    isEditingItem() {
      return !this.formData.id;
    },
    formTitle() {
      return this.isEditingItem
        ? this.$t("createWarehouse")
        : this.$t("editWarehouse");
    },
    zoneModalTitle() {
      return this.zonaFormData.id ? this.$t("editZone") : this.$t("createZone");
    },
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("occupancyPercent"),
          value: "occupancyPercent",
        },
        {
          text: this.$t("address"),
          value: "address",
        },
        {
          text: this.$t("mainWarehouse"),
          value: "parent",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
    nameSearch() {
      return [
        {
          name: this.$t("productName"),
          value: 1,
        },
        {
          name: this.$t("warehouse"),
          value: 2,
        },
      ];
    },
  },
  methods: {
    openInfoVideoModal() {
      this.infoVideoModal = true;
    },
    checkVideoOpenedBefore() {
      if (localStorage.getItem("warehouseInfoVideo")) {
        return;
      }

      setTimeout(() => {
        this.openInfoVideoModal();
        localStorage.setItem("warehouseInfoVideo", "true");
      }, 2000);
    },
    async openWarehouseCreateModal() {
      try {
        this.createButtonLoading = true;
        const { data } = await this.$http.post("/warehouse/check-create");

        this.isCanCreateWarehouse = data.data;

        if (this.isCanCreateWarehouse) {
          this.dialog = true;
        }
      } catch (e) {
        this.limitModal = true;
        this.checkErrorMessageTitle = e.response.data.error_message.title;
        this.checkErrorMessageDescription =
          e.response.data.error_message.description;
        this.checkErrorButtontext = e.response.data.error_message.button
          ? e.response.data.error_message.button
          : this.$t("ok");
        this.checkErrorButtonLink = e.response.data.error_message.redirect_url;
      } finally {
        this.clearLoading();
        this.createButtonLoading = false;
      }
    },
    zoneDialogOpen() {
      this.zonaFormData = {
        ...DEFAULT_ZONA_DATA,
      };
      this.zone_dialog = true;
    },
    activateTab(index) {
      this.activeTabIndex = index;
      if (index === "all") {
        this.currentItems = [...this.items];
      } else {
        this.currentItems = [...this.items].filter((item) => {
          return item.groupId === index;
        });
      }
    },
    clearForm() {
      const { form } = this.$refs;
      this.formData = {
        ...DEFAULT_WAREHOUSE_DATA,
      };
      if (form) form.reset();
      this.dialog = false;
    },
    setMarkedMove({ lat, lng }) {
      this.longitude = String(lng);
      this.latitude = String(lat);
    },
    setZonaMarkedMove({ lat, lng }) {
      this.zonaLatitude = String(lat);
      this.zonaLongitude = String(lng);
    },
    setWarehouse(warehouses) {
      this.warehouses = warehouses;
    },
    setWarehouseGroup(group) {
      this.warehouseGroup = group;
    },
    async getAllWarehouseGroups(name = "") {
      try {
        const params = { name };

        const {
          data: { data, permissions },
        } = await this.$http.get("warehouse-group", {
          params,
        });

        this.permissions.zone = permissions;
        this.setWarehouseGroup(data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    filterChangeSelected: debounce(function () {
      if (this.warehouseFilter.name !== null) {
        if (this.selectedFilter === 1) {
          this.getFilterProductName();
        }
        if (this.selectedFilter === 2) {
          if (this.configuration.page === 1) {
            this.getItems();
          } else {
            this.changePage(1);
          }
        }
      }
    }, 300),
    openView(index) {
      this.$router.push({
        name: "warehouse-view",
        params: { id: this.items[index].id },
        query: { productName: this.warehouseFilter.name },
      });
    },
    async getItems(setQuery) {
      const { page, limit } = this.configuration;
      if (setQuery) {
        await this.$router.push({
          query: { page: this.configuration.page.toString() },
        });
      }
      let params = {
        page: page - 1,
        limit,
        ...this.warehouseFilter,
        type: "WHITE",
      };
      // this.showLoading();
      try {
        const {
          data: { data, total, permissions },
        } = await this.$http.get("warehouse", {
          params,
        });

        this.permissions.warehouses = permissions;
        this.items = data.map((item) => {
          item.parentClassName = "cursor-pointer";
          return item;
        });

        if (this.activeTabIndex === "all") {
          this.currentItems = [...this.items];
        } else {
          this.currentItems = [...this.items].filter(
            (item) => item.groupId === this.activeTabIndex
          );
        }
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        // this.clearLoading();
      }
    },
    async getZones() {
      const { page, limit } = this.configuration;
      let params = { page: page - 1, limit, ...this.warehouseFilter };
      // this.showLoading();
      try {
        const {
          data: { data, permissions },
        } = await this.$http.get("warehouse-group", {
          params,
        });

        this.permissions.zone = permissions;
        this.tabs = [
          { title: this.$t("all"), id: "all" },
          ...data.map((zone) => ({
            title: zone.name_uz,
            id: zone.id,
          })),
        ];
        this.zones = data.map((item) => {
          return item;
        });
        this.setWarehouseGroup(data);
        this.$refs.warehouseListSelect?.clear();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        // this.clearLoading();
      }
    },
    getZoneName(id) {
      const zone = this.zones.filter((zone) => zone.id === id);
      const group = zone[0];
      if (group) {
        return group[`name_uz`];
      } else {
        return this.$t("no");
      }
    },
    editZona(id) {
      const zonaValue = this.zones.find((item) => item.id === id);
      this.zone_dialog = true;
      // this.zonaFormData = getValueByKey(this.zonaFormData, zonaValue);
      this.zonaFormData = {
        nameUz: zonaValue?.name_uz,
        nameEn: zonaValue?.name_en,
        nameRu: zonaValue?.name_ru,
        hidden: zonaValue?.hidden,
        address: zonaValue?.address,
        id: zonaValue?.id,
      };
    },
    edit(item) {
      item.hidden = false;
      this.isAddressHaveGeolocation = false;
      this.dialog = true;
      if (item.parentId) {
        this.warehouses = [{ name: item.parent, id: item.parentId }];
      }
      this.formData = getValueByKey(this.formData, item);
    },
    openAttachZoneModal(item) {
      this.attach_zone = true;
      if (item.parentId) {
        this.warehouses = [{ name: item.parentId, id: item.parentId }];
      }
      this.formData = getValueByKey(this.formData, item);
    },
    async changePage(value) {
      const { page: queryPage } = this.$route.query;
      if (queryPage !== value.toString()) {
        this.showLoading();
        await this.$router.replace({ query: { page: value.toString() } });
        this.configuration.page = value;
        await this.getItems();
        this.clearLoading();
      }
    },
    async deleteItemHandler() {
      try {
        await this.$http.delete(
          "/warehouse/delete?id=" + this.attributeFormData.id
        );
        await this.getItems();
        this.setSuccess({
          title: this.$t("successfullyDeleted"),
        });
      } catch (e) {
        this.$refs.warehouseNotification.open({
          title: e.response.data.error_message.title,
        });
      }
    },
    deleteItem(item) {
      this.confirmDialog = true;
      this.attributeFormData = { ...item };
    },
    deleteZona(id) {
      this.zonaAttributeFormData = this.zones.find((item) => item.id === id);
      this.zoneConfirmDialog = true;
    },
    async deleteZonaHandler() {
      try {
        await this.$http.delete(
          "/warehouse-group/delete?id=" + this.zonaAttributeFormData.id
        );
        await this.getZones();
        this.setSuccess({
          title: this.$t("successfullyDeleted"),
        });
        this.activateTab("all");
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async saveAttribute() {
      this.loading = true;
      this.showLoading();
      try {
        const formData = { ...this.formData };
        formData.nameEn = formData.nameUz;
        formData.nameRu = formData.nameUz;
        if (this.isAddressHaveGeolocation) {
          formData.longitude = this.longitude;
          formData.latitude = this.latitude;
        }
        await this.$http.post("warehouse/save", formData);
        await this.getItems();
        this.dialog = false;
        this.attach_zone = false;
        this.clearForm();
        this.setSuccess({
          title: this.$t("successfullySaved"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
        this.loading = false;
      }
    },
    modalClose() {
      this.clearForm();
      this.dialog = false;
    },
    closeZone() {
      this.zone_dialog = false;
      this.isZoneAddressHaveGeolocation = false;
    },
    async saveZoneAttribute() {
      this.loading = true;
      this.showLoading();
      try {
        const zoneFormData = { ...this.zonaFormData };
        if (!zoneFormData.nameEn) {
          zoneFormData.nameEn = zoneFormData.nameUz;
        }
        if (!zoneFormData.nameRu) {
          zoneFormData.nameRu = zoneFormData.nameUz;
        }
        if (this.isZoneAddressHaveGeolocation) {
          zoneFormData.longitude = this.zonaLongitude;
          zoneFormData.latitude = this.zonaLatitude;
        }
        await this.$http.post("warehouse-group/save", zoneFormData);
        await this.getZones();
        this.zone_dialog = false;
        this.clearForm();
        this.setSuccess({
          title: this.$t("successfullySaved"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
        this.clearLoading();
      }
    },
    async getFilterProductName() {
      const { page, limit } = this.configuration;
      if (this.configuration.page.toString() !== this.$route.query.page) {
        await this.$router.push({
          query: { page: this.configuration.page.toString() },
        });
      }
      let params = { page: page - 1, limit, ...this.warehouseFilter };
      this.showLoading();
      try {
        const {
          data: { data, total },
        } = await this.$http.get("warehouse/search-engine", {
          params,
        });
        if (data) {
          this.items = data.map((item) => {
            item.parentClassName = "cursor-pointer";
            return item;
          });
        }
        this.lastPage = makerPagination({ total, limit }).lastPage;
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    onChangeFilter: debounce(function () {
      if (this.selectedFilter === 1) {
        this.getFilterProductName();
      }
      if (this.selectedFilter === 2) {
        if (this.configuration.page === 1) {
          this.getItems();
        } else {
          this.changePage(1);
        }
      }
    }, 300),
  },
  async created() {
    const { page } = this.$route.query;
    if (page && !isNaN(+page)) {
      this.configuration.page = parseInt(+page);
    }
    this.showLoading();
    await this.getZones();
    await this.getItems();
    this.clearLoading();
    this.checkVideoOpenedBefore();
    this.activateTab("all");
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";

.infoVideo {
  padding: 8px 24px;
  border-radius: 6px;
  transition: 0.3s ease;
  background: rgba(42, 187, 222, 0.33);
  //width: 200px;

  span {
    transition: 0.2s ease;
  }

  &:hover {
    background: #0096b2;

    span {
      color: #fff;
    }
  }
}

.col {
  padding: 6px;
}

.input_container {
  border-radius: 6px;
  border: 1px solid #dfe2e9;
  width: 246px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    outline: #fff;
  }
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  display: none;
  width: 340px;
  color: #fff;
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 110%;
  border-radius: 5px;
  border: 1px solid #e3ebf3;
  background: #fff;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
  padding: 20px;
  gap: 20px;
  /* Shadow 2 */
  box-shadow: 0px 3px 6px 0px rgba(172, 176, 185, 0.1),
    0px 10px 10px 0px rgba(172, 176, 185, 0.09),
    0px 23px 14px 0px rgba(172, 176, 185, 0.05),
    0px 41px 16px 0px rgba(172, 176, 185, 0.01),
    0px 64px 18px 0px rgba(172, 176, 185, 0);

  h4 {
    color: #48545d;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  span {
    color: #7a889b;
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;

    pre {
      color: #48545d;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      display: inline-block;
    }
  }
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 15px;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #e3ebf3 transparent transparent;
}

.tooltip:hover .tooltiptext {
  display: flex;
}

.tabs {
  display: flex;
  overflow-x: auto;
  margin-top: 30px;
  overflow-y: hidden;

  /* width */
  &::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(128, 128, 128, 0.61);
    border-radius: 5px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #0096b2;
    border-radius: 5px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 150, 178, 0.82);
  }
}

.tab {
  margin-right: 5px;
  cursor: pointer;
  background: #f0f0f0;
  padding: 8px 18px;
  border-radius: 5px;
  border: 1px solid #dfe2e9;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  transform: translateY(1px);
  min-width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.active {
  border-bottom: none;
  background: #fff;
}

.tab:hover {
  background-color: #fff;
}

.plus.tab {
  background: #fff;

  span {
    border: 2px solid #dfe2e9;
    border-radius: 50%;
    padding: 5px 8px;
  }
}

.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.tab-content {
  background: #fafbfc;
  border-radius: 5px;
  border: 1px solid #dfe2e9;
  border-top-left-radius: 0;
  padding: 16px;
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.card_container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 15px;
}

.text-primary {
  color: rgb(0 150 178);
  &:hover {
    color: #fff;
  }
}

@media screen and (max-width: 460px) {
  .zona_btn_container {
    flex-direction: column;
  }
  .card_container {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }

  .actions_container {
    flex-direction: column;
  }
}

.modalTitle {
  font-family: "Rubik", sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 28.44px;
  color: #48545d;
}

.modalDescription {
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 21.33px;
  text-align: center;
  color: #90a5be;
}
</style>
